import { render, staticRenderFns } from "./estructuraFamiliar.vue?vue&type=template&id=65196247&scoped=true&"
import script from "./estructuraFamiliar.vue?vue&type=script&lang=js&"
export * from "./estructuraFamiliar.vue?vue&type=script&lang=js&"
import style0 from "./estructuraFamiliar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./estructuraFamiliar.vue?vue&type=style&index=1&id=65196247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65196247",
  null
  
)

export default component.exports